class FeaturedProducts extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.sectionId = this.getAttribute('data-section-id');

    // Store bound methods so add/removeEventListener match
    this.onSectionLoad = this.onSectionLoad.bind(this);
    this.onSectionUnload = this.onSectionUnload.bind(this);
  }

  connectedCallback() {
    this.init();
    document.addEventListener('shopify:section:load', this.onSectionLoad);
    document.addEventListener('shopify:section:unload', this.onSectionUnload);
  }

  disconnectedCallback() {
    this.destroy();
    document.removeEventListener('shopify:section:load', this.onSectionLoad);
    document.removeEventListener('shopify:section:unload', this.onSectionUnload);
  }

  init() {
    if (window.Swiper && this.sectionId) {
      const selector = `#featured-products-${this.sectionId}`;
      const swiperEl = document.querySelector(selector);

      // Prevent duplicate swiper initialization
      if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

      this.swiper = new Swiper(selector, {
        slidesPerView: 1.4,
        spaceBetween: 0,
        centeredSlides: false,
        // Add right-side gutter so the last card isn't flush to the edge
        slidesOffsetAfter: 20,
        autoHeight: false,
        navigation: {
          nextEl: `${selector} .featured-products__swiper-next`,
          prevEl: `${selector} .featured-products__swiper-prev`,
        },
        pagination: {
          el: `${selector} .featured-products__pagination`,
          clickable: true,
        },
        breakpoints: {
          640: { slidesPerView: 2, spaceBetween: 20, centeredSlides: false, slidesOffsetAfter: 20 },
          990: { slidesPerView: 3, spaceBetween: 20, centeredSlides: false, speed: 0, slidesOffsetAfter: 20 },
          1200: { slidesPerView: 4, spaceBetween: 0, centeredSlides: false, speed: 0, slidesOffsetAfter: 0 },
          1500: { slidesPerView: 4, spaceBetween: 0, centeredSlides: false, speed: 0, slidesOffsetAfter: 0 },
        },
        loop: false,
        watchOverflow: true,
        grabCursor: false,
        // Set speed to 0 to disable slide animations
        speed: 300,
      });
    }
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  onSectionLoad(e) {
    if (e.detail && e.detail.sectionId === this.sectionId) {
      this.destroy();
      this.init();
    }
  }

  onSectionUnload(e) {
    if (e.detail && e.detail.sectionId === this.sectionId) {
      this.destroy();
    }
  }
}

if (!customElements.get('featured-products')) {
  customElements.define('featured-products', FeaturedProducts);
}
